import config from '../config/apiConfig';

const getHeaders = () => {
    return {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('token')
    };
};

const getUrl = (endpoint) => {
    const base = config.api_url.endsWith('/') ? config.api_url : `${config.api_url}/`;
    return base + endpoint;
};

export const obtenerMesas = async () => {
    const res = await fetch(getUrl('api/v1/mesas'), { headers: getHeaders() });
    return await res.json();
};

export const crearMesa = async (nombre, zonaId = null) => {
    const res = await fetch(getUrl('api/v1/mesas'), {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ nombre, zona_id: zonaId })
    });
    return await res.json();
};

export const liberarMesa = async (mesaId) => {
    // Ajusta la URL según cómo se llame tu endpoint en Python
    const response = await fetch(config.api_url + `/api/v1/mesas/${mesaId}/liberar`, {
        method: 'POST',
        headers: getHeaders()
    });
    if (!response.ok) throw new Error("Error al liberar mesa");
    return await response.json();
};

export const actualizarMesa = async (id, nombre, zonaId = null) => {
    const res = await fetch(getUrl(`api/v1/mesas/${id}`), {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify({ nombre, zona_id: zonaId })
    });
    return await res.json();
};

export const eliminarMesa = async (id) => {
    const res = await fetch(getUrl(`api/v1/mesas/${id}`), {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};

export const asignarGarzonMesa = async (mesaId, garzonNombre) => {
    const res = await fetch(getUrl(`api/v1/mesas/${mesaId}/asignar-garzon`), {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ garzon_nombre: garzonNombre || null })
    });
    return await res.json();
};

// Guarda el orden manual de la grilla de mesas.
// ordenes: [{ id, orden }] en el orden en que se deben pintar.
export const guardarOrdenMesas = async (ordenes) => {
    const res = await fetch(getUrl('api/v1/mesas/orden'), {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify({ ordenes })
    });
    if (!res.ok) throw new Error("No se pudo guardar el orden de las mesas");
    return await res.json();
};

// Guarda la celda (columna/fila) de cada mesa en el mapa del salon.
// posiciones: [{ id, pos_x, pos_y }]  pos_x = columna, pos_y = fila.
export const guardarPosicionesMesas = async (posiciones) => {
    const res = await fetch(getUrl('api/v1/mesas/posiciones'), {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify({ posiciones })
    });
    if (!res.ok) throw new Error("No se pudieron guardar las posiciones de las mesas");
    return await res.json();
};

export const obtenerZonas = async () => {
    const res = await fetch(getUrl('api/v1/zonas-mesas'), { headers: getHeaders() });
    return await res.json();
};

export const crearZona = async (nombre) => {
    const res = await fetch(getUrl('api/v1/zonas-mesas'), {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ nombre })
    });
    return await res.json();
};

export const actualizarZona = async (id, nombre) => {
    const res = await fetch(getUrl(`api/v1/zonas-mesas/${id}`), {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify({ nombre })
    });
    return await res.json();
};

export const eliminarZona = async (id) => {
    const res = await fetch(getUrl(`api/v1/zonas-mesas/${id}`), {
        method: 'DELETE',
        headers: getHeaders()
    });
    return await res.json();
};

export const obtenerTerminales = async () => {
    const res = await fetch(getUrl('api/v1/mesas/terminales'), { headers: getHeaders() });
    return await res.json();
};